import React, { Fragment, useState, useEffect } from 'react';
import { Container, Row, Col, Accordion, Alert } from 'react-bootstrap';
import Servico from './carta/servico';
import Carta from './carta'
import CartaServicoService from '../../services/cartaServico';
import SecretariaService from '../../services/secretaria';
import FormBusca from './form_busca';

const Cartas = () => {
    const [servicosPorSecretaria, setServicosPorSecretaria] = useState([]);
    const [secretarias, setSecretarias] = useState([]);
    const [cartas, setCartas] = useState([]);
    const [vazio, setVazio] = useState(false)

    const montaSec = async () => {
        const secs = await SecretariaService.listar()
        setSecretarias(secs.data)
    }

    async function fetchCartas() {
        const response = await CartaServicoService.listar();
        if (response.data.length >= 1) {
            setCartas(response.data)
            setVazio(false)
        } else {
            setCartas([])
            setVazio(true)
        }
    }

    useEffect(() => {
        async function fetchData() {
            try {
                await montaSec();
                const response = await CartaServicoService.listar();

                // Agrupar os serviços por secretaria
                const servicosAgrupados = {};
                response.data.forEach(servico => {
                    const { secretaria, ...dadosServico } = servico;
                    if (!servicosAgrupados[secretaria]) {
                        servicosAgrupados[secretaria] = [];
                    }
                    servicosAgrupados[secretaria].push(dadosServico);
                });

                setServicosPorSecretaria(Object.entries(servicosAgrupados));
            } catch (error) {
                console.error('Erro ao buscar dados da API:', error);
                setVazio(true);
            }
        }

        fetchData();
    }, []);

    // console.log(servicosPorSecretaria)

    if (servicosPorSecretaria.length === 0) {
        return <div>Carregando...</div>;
    } else {
        return (
            <Fragment>
                <Container>
                    <Row xs={1}>
                        <Col>
                            <h2>Carta de Serviços ao Cidadão</h2>
                        </Col>
                    </Row>
                    <Fragment>
                        <FormBusca
                            setVazio={setVazio}
                            fetchCartas={fetchCartas}
                            secretarias={secretarias}
                            setCartas={setCartas}
                            cartas={cartas}
                        />
                    </Fragment>
                    {vazio ? <Fragment>
                        <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                    </Fragment> :
                        <Fragment>
                            <br />
                            {cartas.length > 0 ?
                                <Fragment>
                                    <Row xs={1}>
                                        {cartas.map((carta, index) =>
                                            <Fragment>
                                                <Accordion>
                                                    <Accordion.Item eventKey={index}>
                                                        <Accordion.Header><strong>{carta.secretaria}: {carta.servico}</strong></Accordion.Header>
                                                        <Accordion.Body>
                                                            <Accordion>
                                                                <Servico
                                                                    key={index}
                                                                    servico={carta.servico}
                                                                    finalidade={carta.finalidade}
                                                                    requisitos={carta.requisitos}
                                                                    etapas={carta.etapas}
                                                                    tempo={carta.tempo}
                                                                    local={carta.local}
                                                                />
                                                            </Accordion>
                                                        </Accordion.Body>
                                                    </Accordion.Item><br /><br />
                                                </Accordion>
                                            </Fragment>
                                        )}
                                    </Row>
                                </Fragment> :
                                <Fragment>
                                    <Row xs={1}>
                                        {servicosPorSecretaria.map((item, index) => (
                                            <Fragment>
                                                <Accordion key={index}>
                                                    <Carta
                                                        key={index}
                                                        servicos={item[1]}
                                                        secretaria={item[0]}
                                                    />

                                                </Accordion>
                                            </Fragment>
                                        ))}
                                    </Row>
                                </Fragment>}
                        </Fragment>}
                </Container >
            </Fragment >
        );
    }
}

export default Cartas;